import React from "react";
import { Menu, Search } from "lucide-react";

interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header: React.FC<HeaderProps> = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <header className="sticky top-0 z-10 flex bg-white shadow-md dark:bg-boxdark rounded-lg ml-2 p-2">
      <div className="flex flex-grow items-center justify-between px-4 py-4 md:px-16 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="block lg:hidden"
          >
            <Menu className="text-gray-600" />
          </button>
          <h1 className="text-xl font-medium text-custom-blue7">
            Hello Admin!
          </h1>
        </div>
        {/* <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <input
            type="text"
            placeholder="Search"
            className="bg-custom-blue1 pl-10 pr-4 py-2 rounded-md w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div> */}
      </div>
    </header>
  );
};

export default Header;
